export class UpdateFkEditorUseCase{
  constructor(repository) {
    this.repository = repository
  }
  async execute(ID_FARM,FK_EDITOR){
    await this.repository.updateFkEditor(ID_FARM,FK_EDITOR)
  }
}
